module.exports = __webpack_public_path__ + "img/tag-video-2106bf46.c4593aa5.png";